import styled from 'styled-components'
import {
  alignItems,
  AlignItemsProps,
  grid,
  GridProps,
  position,
  space,
  border,
  SpaceProps,
  PositionProps,
  BorderProps,
  layout,
  LayoutProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
} from 'styled-system'

type Props = GridProps &
  SpaceProps &
  AlignItemsProps &
  PositionProps &
  BorderProps &
  LayoutProps &
  ColorProps &
  FlexboxProps

const Grid = styled('div')<Props>(
  {
    display: 'grid',
  },
  position,
  grid,
  border,
  alignItems,
  space,
  layout,
  color,
  flexbox,
)

export default Grid
